import { render, staticRenderFns } from "./coupons.vue?vue&type=template&id=034c1a62"
import script from "./coupons.vue?vue&type=script&lang=js"
export * from "./coupons.vue?vue&type=script&lang=js"
import style0 from "./coupons.vue?vue&type=style&index=0&id=034c1a62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports